// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"beu_a bhp_bk bhp_bl bhp_bo","SwipeLeftToClose--animating":"beu_b"};